import { facturaPosVerPath } from '../../../config/routes';
import type { ArticuloInfo360ActividadItem, ArticuloInfo360Documento } from './types';

export type ArticuloInfo360DocumentoAccion =
  | { kind: 'ruta'; path: string; label: string };

type DocumentoConsultable = Pick<ArticuloInfo360Documento, 'tipoCodigo' | 'nroFormulario' | 'numero'>
  | Pick<ArticuloInfo360ActividadItem, 'tipoCodigo' | 'nroFormulario'>;

export function resolverAccionDocumentoArticulo(
  documento: DocumentoConsultable,
): ArticuloInfo360DocumentoAccion | null {
  const nroFormulario = documento.nroFormulario;
  if (nroFormulario == null || nroFormulario <= 0) return null;

  switch ((documento.tipoCodigo ?? '').trim()) {
    case '1':
      return {
        kind: 'ruta',
        path: facturaPosVerPath(nroFormulario),
        label: 'Ver factura',
      };
    case '12':
      return {
        kind: 'ruta',
        path: `/ventas/pedidos/${nroFormulario}/ver`,
        label: 'Ver pedido',
      };
    case 'FC':
      return {
        kind: 'ruta',
        path: `/compras/facturas/${nroFormulario}`,
        label: 'Ver factura de compra',
      };
    case 'OC':
      return {
        kind: 'ruta',
        path: `/compras/ordenes/${nroFormulario}`,
        label: 'Ver orden de compra',
      };
    default:
      return null;
  }
}